<!-- 邮储银行集合页面（app调试使用） -->
<template>
  <div class="postal-bank-home">
    <ul>
      <li
        v-for="item in list"
        :key="item.name"
        class="btn"
        :style="item.style"
        @click="() => topage(item)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PostalBankHome',
  data() {
    return {
      title: '邮储银行集合页面',
      exchangeCode: '',
      list: [
        {
          name: '云南邮储白名单H5-测试',
          path: 'https://mapa.quancangyun.cn/dev/ydsh-ph-h5-bankv3/yunnanPostalWhiteList',
          style: 'color: #fff;background: #da9978e8;'
        },
        {
          name: '云南邮储白名单H5-开发',
          path: 'https://mapa.quancangyun.cn/dev/ydsh-ph-h5-bankv3/yunnanPostalWhiteList',
          style: 'color: #fff;background: #9d6a43'
        },
        {
          name: '云南邮储白名单H5-本地',
          path: 'https://mapa.quancangyun.cn/dev/lmq1/#/yunnanPostalWhiteList?vConsole=1',
          style: 'color: #fff;background: #e97e2b;'
        },
      ],
    }
  },
  created() {
    document.title = this.title
  },
  methods: {
    topage(item) {
      window.location.href = item.path
    },
  }
}
</script>

<style lang="less">
.postal-bank-home {
  font-size: 14px;
  line-height: 3.5;
  padding: 20px;

  .btn {
    padding: 0 10px;
  }
}
</style>
